import { useEffect } from 'react';

interface PerformanceMetric {
  name: string;
  value: number;
  timestamp: number;
}

export const PerformanceMonitor = () => {
  useEffect(() => {
    // Monitor Core Web Vitals - only in development or when explicitly enabled
    if ('PerformanceObserver' in window && import.meta.env.DEV) {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          const metric: PerformanceMetric = {
            name: entry.name,
            value: entry.startTime,
            timestamp: Date.now()
          };
          
          // Only log in development
          console.log('[Performance]', metric);
        }
      });

      observer.observe({ entryTypes: ['navigation', 'resource', 'measure'] });

      return () => observer.disconnect();
    }
  }, []);

  return null;
};
